import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TranslatedText from "./TranslatedText";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import myRestClient from "../common/restClient";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import FileCopyOutlinedIcon from "@material-ui/icons/ContentCopy";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Tooltip from "@material-ui/core/Tooltip";
import Snackbar from "@material-ui/core/Snackbar";
import copy from "copy-to-clipboard";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import { POLICY_INSTALLATIONS } from "../common/rolesManagement";
import RefreshListActions from "../resources/Installations/RefreshListActions";
import IconRocket from "../common/icons/svgRocket";
import DeleteIcon from "@material-ui/icons/Delete";
import { showNotification } from "ra-core";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { getInstallationTypeId } from "../common/utilities";
import {
    detailsDecodeValue,
    detailsRenderKey
} from "../common/detailsDecodeValue";
import { OperationType } from "../common/operationTypes";

const GRAFANA_BASE_URL = "https://teamsystem.grafana.net";
const GRAFANA_DASHBOARD_SYSERR = "lm6dtxv/tsc-oomkill";
const GRAFANA_DASHBOARD_CLUSTER_SYSTEM = "node-fleet/linux-node-fleet-overview";
const GRAFANA_DASHBOARD_CLUSTER_DOCKER =
    "lmrmq8x/tsc-metering-container-dashboard";
const GRAFANA_DASHBOARD_METERING = "lmvbv2q/tsc-metering-dashboard";
const GRAFANA_DASHBOARD_CS = "tsc-delivery-overview/tsc-delivery-overview";

class DetailsDialogButton extends React.Component {
    state = {
        open: false,
        loading: true,
        info: null,
        snackBar: false,
        menuAnchor: null,
        showDB: false,
        showContainer: false,
        studio_id: null,
        enterprise_id: null,
        enterprise12_id: null,
        enterprise10_id: null,
        operation: [],
        assistance: {
            status: "CARICAMENTO",
            id: null,
            openConfirmationDialog: false,
            confirmInProgress: false,
            openCancellationDialog: false,
            cancellationInProgress: false
        },
        statusBackup: null,
        loadingBackup: true,
        statusLicensesUpdate: null,
        loadingLicensesUpdate: true,
        statusMenuUpdate: null,
        loadingMenuUpdate: true,
        enterpriseOperationsStatus: {}
    };
    componentDidMount = () => {
        getInstallationTypeId("STUDIO").then(inst_id =>
            this.setState({ studio_id: inst_id })
        );
        getInstallationTypeId("ENTERPRISE").then(inst_id =>
            this.setState({ enterprise_id: inst_id })
        );
        getInstallationTypeId("ENT12").then(inst_id =>
            this.setState({ enterprise12_id: inst_id })
        );
        getInstallationTypeId("ENT10").then(inst_id =>
            this.setState({ enterprise10_id: inst_id })
        );
    };
    refreshAssistanceStatus = async () => {
        myRestClient("GET_ONE_BY_PARAMETERS", "database-support", {
            installation_id: this.props.data.id
        }).then(
            r => {
                this.setState({
                    assistance: {
                        status: r.data.status,
                        id: r.data.id
                    }
                });
            },
            e => {
                this.setState({
                    assistance: {
                        status: "ERRORE",
                        id: null
                    }
                });
            }
        );
    };

    handleClickOpen = async () => {
        this.setState({ open: true, loading: true });

        if (this.props.data) {
            const params = {
                id: this.props.data.id
            };
            await myRestClient("GET_ONE", "installation-info", params).then(
                response => {
                    this.setState({
                        info: response.data,
                        loading: false
                    });
                },
                err => {
                    this.setState({
                        info: err,
                        loading: false
                    });
                }
            );
            if (
                this.props.data.installation_type_id ===
                    this.state.enterprise_id ||
                this.props.data.installation_type_id ===
                    this.state.enterprise12_id ||
                this.props.data.installation_type_id ===
                    this.state.enterprise10_id
            ) {
                await this.refreshAssistanceStatus();
                this.assistanceInterval = setInterval(() => {
                    this.refreshAssistanceStatus();
                }, 20000);
            }
            // Solo se enterprise
            if (
                this.props.data.installation_type_id ===
                    this.state.enterprise_id ||
                this.props.data.installation_type_id ===
                    this.state.enterprise10_id
            ) {
                this.checkEnterpriseOperationExisting([
                    OperationType.LicenseUpdate,
                    OperationType.MenuUpdate,
                    OperationType.GenerateBackup
                ]);
            }
        }
    };

    handleClose = () => {
        this.setState({ open: false });
        clearInterval(this.assistanceInterval);
    };

    myDialog() {
        const info = this.state.info;
        return (
            <React.Fragment>
                {info && this.renderInfoTable(info)}
                {!info && "Cannot load"}
            </React.Fragment>
        );
    }

    renderInfoTable(info) {
        let translatedInfo = this.translateInfo(info);
        let keys = Object.keys(translatedInfo);
        keys.sort();
        return (
            <Table>
                <TableBody>
                    {keys.map(key => (
                        <TableRow key={key}>
                            <TableCell>
                                <b>{key}</b>
                            </TableCell>
                            <TableCell>{translatedInfo[key]}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    translateInfo(info) {
        let result = {};
        Object.keys(info).forEach(key => {
            // Se detailsDecodeValue restituisce un React element, lo uso direttamente
            const value = this.decodeValues(key, info[key]);
            const unit = this.renderUnitOfMeasurement(key);
            result[
                detailsRenderKey(key, this.props.data.installation_type_id)
            ] = React.isValidElement(value) ? value : value + unit;
        });
        return result;
    }

    decodeValues(key, value) {
        const installationType = this.props.data.installation_type_id;
        return detailsDecodeValue(key, value, installationType);
    }

    renderUnitOfMeasurement(key) {
        switch (key) {
            case "sys_ram":
            case "sys_ram_limit":
                return " MB";
            case "uas":
                return " PDL";
            case "volume_pused":
                return "%";
            case "volume_size":
                return " GB";
            case "sys_cpu":
                return " crediti";
            default:
                return "";
        }
    }

    renderSSHButtons(instance_id) {
        return (
            <Tooltip title="Apri sessione SSH in una nuova finestra">
                <Button
                    color="primary"
                    target="_blank"
                    onClick={() => {
                        window.open(
                            "https://eu-west-1.console.aws.amazon.com/systems-manager/session-manager/" +
                                instance_id +
                                "?region=eu-west-1",
                            "_blank"
                        );
                    }}
                >
                    <DesktopWindowsIcon />
                </Button>
            </Tooltip>
        );
    }
    renderCopySSHCommand(instance_id) {
        return (
            <Tooltip title="Copia comando terminale">
                <Button
                    color="primary"
                    target="_blank"
                    onClick={() => {
                        copy("aws ssm start-session --target " + instance_id);
                        this.setState({
                            snackBar: true
                        });
                    }}
                >
                    <FileCopyOutlinedIcon />
                </Button>
            </Tooltip>
        );
    }

    refreshEnterpriseOptionsMenu = () => {
        const params = {
            installation_id: this.props.data.id
        };
        myRestClient("GET_ONE_BY_PARAMETERS", "generate-backup", params).then(
            response => {
                this.setState({
                    statusBackup: response.data["status"],
                    loadingBackup: false
                });
            },
            err => {
                this.setState({
                    statusBackup: err,
                    loadingBackup: false
                });
            }
        );
        myRestClient("GET_ONE_BY_PARAMETERS", "licenses-update", params).then(
            response => {
                this.setState({
                    statusLicensesUpdate: response.data["status"],
                    loadingLicensesUpdate: false
                });
            },
            err => {
                this.setState({
                    statusLicensesUpdate: err,
                    loadingLicensesUpdate: false
                });
            }
        );
        myRestClient("GET_ONE_BY_PARAMETERS", "menu-update", params).then(
            response => {
                this.setState({
                    statusMenuUpdate: response.data["status"],
                    loadingMenuUpdate: false
                });
            },
            err => {
                this.setState({
                    statusMenuUpdate: err,
                    loadingMenuUpdate: false
                });
            }
        );
    };

    checkEnterpriseOperationExisting(operations) {
        if (this.props.data.installation_type_id) {
            const params = {
                pagination: { page: 1, perPage: 10000 },
                sort: { field: "name", order: "asc" },
                filter: {
                    installation_type_id: this.props.data.installation_type_id
                },
                filter_type: operations // array di operazioni
            };
            myRestClient("GET_LIST", "operations", params).then(
                result => {
                    // Ottieni i nomi delle operazioni trovate
                    const foundOps = result.data.map(
                        item => item.operation_type_name
                    );
                    // Costruisci lo stato per ogni operazione richiesta
                    const status = {};
                    operations.forEach(op => {
                        status[op] = foundOps.includes(op);
                    });
                    this.setState({
                        enterpriseOperationsStatus: status
                    });
                },
                error => {
                    // In caso di errore, tutte le operazioni sono false
                    const status = {};
                    operations.forEach(op => {
                        status[op] = false;
                    });
                    this.setState({
                        enterpriseOperationsStatus: status
                    });
                }
            );
        }
    }

    renderMoreOptionsMenuEnterprise() {
        const handleOpenMenuEnterprise = event => {
            this.setState({
                menuAnchor: event.currentTarget
            });
            this.refreshEnterpriseOptionsMenu();
            this.assistanceInterval = setInterval(() => {
                this.refreshEnterpriseOptionsMenu();
            }, 20000);
        };
        const handleCloseMenuEnterprise = () => {
            this.setState({
                menuAnchor: null
            });
            clearInterval(this.assistanceInterval);
        };

        const handleUpdateLicenses = () => {
            const body = {
                data: {
                    installation_id: this.props.data.id
                }
            };
            this.setState({ statusLicensesUpdate: "ESEGUITO" });
            myRestClient("CREATE", "licenses-update", body).then(
                response => {
                    this.props.showNotification(
                        <TranslatedText
                            resource_name={`resources.installations.actions.start_operation`}
                        />
                    );
                    // Dopo 30 secondi aggiorna lo stato reale
                    setTimeout(() => {
                        this.refreshEnterpriseOptionsMenu();
                    }, 30000);
                },
                err => {
                    this.props.showNotification(err.message);
                    // Dopo 30 secondi aggiorna lo stato reale
                    setTimeout(() => {
                        this.refreshEnterpriseOptionsMenu();
                    }, 30000);
                }
            );
        };

        const handleUpdateMenu = () => {
            const body = {
                data: {
                    installation_id: this.props.data.id
                }
            };
            this.setState({ statusMenuUpdate: "ESEGUITO" });
            myRestClient("CREATE", "menu-update", body).then(
                response => {
                    this.props.showNotification(
                        <TranslatedText
                            resource_name={`resources.installations.actions.start_operation`}
                        />
                    );
                    // Dopo 30 secondi aggiorna lo stato reale
                    setTimeout(() => {
                        this.refreshEnterpriseOptionsMenu();
                    }, 30000);
                },
                err => {
                    this.props.showNotification(err.message);
                    // Dopo 30 secondi aggiorna lo stato reale
                    setTimeout(() => {
                        this.refreshEnterpriseOptionsMenu();
                    }, 30000);
                }
            );
        };

        const handleStatusBackup = () => {
            const body = {
                data: {
                    installation_id: this.props.data.id
                }
            };
            this.setState({ statusBackup: "ESEGUITO" });
            myRestClient("CREATE", "generate-backup", body).then(
                response => {
                    this.props.showNotification(
                        <TranslatedText
                            resource_name={`resources.installations.actions.start_operation`}
                        />
                    );
                    // Dopo 30 secondi aggiorna lo stato reale
                    setTimeout(() => {
                        this.refreshEnterpriseOptionsMenu();
                    }, 30000);
                },
                err => {
                    this.props.showNotification(err.message);
                    // Dopo 30 secondi aggiorna lo stato reale
                    setTimeout(() => {
                        this.refreshEnterpriseOptionsMenu();
                    }, 30000);
                }
            );
        };

        return (
            <div style={{ display: "inline-block" }}>
                <Tooltip title="Altro">
                    <Button color="primary" onClick={handleOpenMenuEnterprise}>
                        <MoreVertIcon />
                    </Button>
                </Tooltip>
                <Menu
                    id="simple-menu"
                    anchorEl={this.state.menuAnchor}
                    keepMounted
                    open={this.state.menuAnchor != null ? true : false}
                    onClose={handleCloseMenuEnterprise}
                >
                    <MenuItem
                        disabled={
                            this.state.statusLicensesUpdate !== "DISPONIBILE"
                        }
                        onClick={handleUpdateLicenses}
                    >
                        Aggiorna licenze e menù
                    </MenuItem>
                    <MenuItem
                        disabled={this.state.statusMenuUpdate !== "DISPONIBILE"}
                        onClick={handleUpdateMenu}
                    >
                        Aggiorna menù
                    </MenuItem>
                    <MenuItem
                        disabled={this.state.statusBackup !== "DISPONIBILE"}
                        onClick={handleStatusBackup}
                    >
                        Genera backup
                    </MenuItem>
                </Menu>
            </div>
        );
    }

    renderMoreOptionsMenu(data) {
        const handleOpenMenu = event => {
            this.setState({
                menuAnchor: event.currentTarget
            });
        };

        const handleCloseMenu = () => {
            this.setState({
                menuAnchor: null
            });
        };

        const showContainerDialog = () => {
            this.setState({
                menuAnchor: null,
                showContainer: true
            });
        };

        const showDBDialog = () => {
            this.setState({
                menuAnchor: null,
                showDB: true
            });
        };

        const openClusterMonitoringSystem = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                GRAFANA_BASE_URL +
                    "/d/" +
                    GRAFANA_DASHBOARD_CLUSTER_SYSTEM +
                    "?orgId=1&from=now-30m&to=now&timezone=browser&var-prometheus_datasource=cf9o4aexuohdsd&var-cluster=" +
                    this.state.info.cluster_name +
                    "&var-job=$__all&var-instance=$__all&var-loki_datasource=bf9o2vkid4w00c&var-custom_filter=&refresh=30s",
                "_blank"
            );
        };

        const openClusterMonitoringDocker = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                GRAFANA_BASE_URL +
                    "/d/" +
                    GRAFANA_DASHBOARD_CLUSTER_DOCKER +
                    "?orgId=1&from=now-15m&to=now&timezone=browser&var-container_name=$__all&var-deployment_environment=$__all&var-datasource=bf9o2vkid4w00c&var-cluster_name=" +
                    this.state.info.cluster_name +
                    "&refresh=1m",
                "_blank"
            );
        };

        const openCustomerMeteringOverview = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                GRAFANA_BASE_URL +
                    "/d/" +
                    GRAFANA_DASHBOARD_METERING +
                    "?orgId=1&from=now-1h&to=now&timezone=browser&var-datasource=bf9o2vkid4w00c&var-deployment_environment=$__all&var-cluster_name=" +
                    this.state.info.cluster_name +
                    "&var-container_name=" +
                    this.state.info.customer +
                    "&refresh=1m",
                "_blank"
            );
        };

        const openCustomerMeteringStart = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                GRAFANA_BASE_URL +
                    "/d/" +
                    GRAFANA_DASHBOARD_METERING +
                    "?orgId=1&from=now-1h&to=now&timezone=browser&var-datasource=bf9o2vkid4w00c&var-deployment_environment=$__all&var-cluster_name=$__all&var-container_name=" +
                    this.state.info.customer +
                    "&refresh=1m",
                "_blank"
            );
        };

        const openSystemErrors = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                GRAFANA_BASE_URL +
                    "/d/" +
                    GRAFANA_DASHBOARD_SYSERR +
                    "?orgId=1&from=now-7d&to=now&timezone=browser&var-deployment_environment=$__all&var-host=$__all&var-customer_tcc_id=" +
                    this.state.info.customer +
                    "&refresh=30s",
                "_blank"
            );
        };

        const openDashboardCS = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                GRAFANA_BASE_URL +
                    "/d/" +
                    GRAFANA_DASHBOARD_CS +
                    "?orgId=1&from=now-24h&to=now&timezone=browser&var-logs_datasource=bf9o2vkid4w00c&var-metrics_datasource=cf9o4aexuohdsd&var-deployment_environment=$__all&var-cluster=" +
                    this.state.info.cluster_name +
                    "&var-instance=$__all&refresh=30s",
                "_blank"
            );
        };

        return (
            <div style={{ display: "inline-block" }}>
                <Tooltip title="Altro">
                    <Button color="primary" onClick={handleOpenMenu}>
                        <MoreVertIcon />
                    </Button>
                </Tooltip>
                <Menu
                    id="simple-menu"
                    anchorEl={this.state.menuAnchor}
                    keepMounted
                    open={this.state.menuAnchor != null ? true : false}
                    onClose={handleCloseMenu}
                >
                    {this.props.permissions.includes(
                        POLICY_INSTALLATIONS.GET_INFO
                    ) && (
                        <MenuItem onClick={showContainerDialog}>
                            Accesso container
                        </MenuItem>
                    )}
                    <Divider />
                    {this.props.permissions.includes(
                        POLICY_INSTALLATIONS.GET_INFO
                    ) && (
                        <MenuItem onClick={showDBDialog}>
                            Accesso database
                        </MenuItem>
                    )}
                    <Divider />
                    <MenuItem onClick={openClusterMonitoringSystem}>
                        Monitoraggio Cluster (system)
                    </MenuItem>
                    <MenuItem onClick={openClusterMonitoringDocker}>
                        Monitoraggio Cluster (docker)
                    </MenuItem>
                    <MenuItem onClick={openCustomerMeteringOverview}>
                        Metering cliente (overview)
                    </MenuItem>
                    <MenuItem onClick={openCustomerMeteringStart}>
                        Metering cliente (START)
                    </MenuItem>
                    <MenuItem onClick={openSystemErrors}>
                        Errori di sistema
                    </MenuItem>
                    <MenuItem onClick={openDashboardCS}>Dashboard CS</MenuItem>
                </Menu>
            </div>
        );
    }

    renderEnterpriseAssistance() {
        const handleOpenConfirmationDialog = event => {
            this.setState({
                assistance: {
                    status: this.state.assistance.status,
                    id: this.state.assistance.id,
                    openConfirmationDialog: true,
                    openCancellationDialog: false
                }
            });
        };
        const handleCancelConfirmationDialog = event => {
            this.setState({
                assistance: {
                    status: this.state.assistance.status,
                    id: this.state.assistance.id,
                    openConfirmationDialog: false,
                    openCancellationDialog: false,
                    confirmInProgress: this.state.assistance.confirmInProgress,
                    cancellationInProgress: this.state.assistance
                        .cancellationInProgress
                }
            });
        };
        const handleOpenCancellationDialog = event => {
            this.setState({
                assistance: {
                    status: this.state.assistance.status,
                    id: this.state.assistance.id,
                    openConfirmationDialog: false,
                    openCancellationDialog: true
                }
            });
        };
        const handleCancelCancellationDialog = event => {
            this.setState({
                assistance: {
                    status: this.state.assistance.status,
                    id: this.state.assistance.id,
                    openConfirmationDialog: false,
                    openCancellationDialog: false,
                    confirmInProgress: this.state.assistance.confirmInProgress,
                    cancellationInProgress: this.state.assistance
                        .cancellationInProgress
                }
            });
        };
        const handleStartProvisioning = event => {
            this.setState({
                assistance: {
                    confirmInProgress: true
                }
            });
            const body = {
                data: {
                    installation_id: this.props.data.id
                }
            };
            myRestClient("CREATE", "database-support", body).then(
                result => {
                    this.setState({
                        assistance: {
                            confirmInProgress: false,
                            openConfirmationDialog: false
                        }
                    });
                    this.refreshAssistanceStatus();
                },
                error => {
                    this.setState({
                        assistance: {
                            confirmInProgress: false,
                            openConfirmationDialog: false
                        }
                    });
                    this.refreshAssistanceStatus();
                    showNotification(error.message);
                }
            );
        };
        const handleDeleteProvisioning = event => {
            this.setState({
                assistance: {
                    cancellationInProgress: true
                }
            });
            const query = {
                id: this.props.data.id
            };
            myRestClient("DELETE", "database-support", query).then(
                result => {
                    this.setState({
                        assistance: {
                            cancellationInProgress: false,
                            openCancellationDialog: false
                        }
                    });
                    this.refreshAssistanceStatus();
                },
                error => {
                    this.setState({
                        assistance: {
                            cancellationInProgress: false,
                            openCancellationDialog: false
                        }
                    });
                    this.refreshAssistanceStatus();
                    showNotification(error.message);
                }
            );
        };
        const statusColor =
            this.state.assistance.status === "ASSENTE"
                ? "#9B9B9B"
                : this.state.assistance.status === "PRONTO"
                ? "#12C51D"
                : this.state.assistance.status === "ERRORE"
                ? "#FF0000"
                : "#F58420";
        return (
            <React.Fragment>
                <Dialog
                    disableBackdropClick
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.assistance.openConfirmationDialog}
                >
                    <DialogTitle>
                        <b>Avvio assistenza</b>
                    </DialogTitle>
                    <DialogContent>
                        Sei sicuro di voler avviare la sessione di assistenza?
                    </DialogContent>
                    <DialogActions>
                        <div
                            align="center"
                            style={{
                                visibility: this.state.assistance
                                    .confirmInProgress
                                    ? "visible"
                                    : "hidden"
                            }}
                        >
                            {<CircularProgress />}
                        </div>
                        {!this.state.assistance.confirmInProgress && (
                            <div>
                                {" "}
                                <Button
                                    onClick={handleCancelConfirmationDialog}
                                    color="primary"
                                >
                                    Annulla
                                </Button>
                                <Button
                                    onClick={handleStartProvisioning}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Ok
                                </Button>
                            </div>
                        )}
                    </DialogActions>
                </Dialog>
                <Dialog
                    disableBackdropClick
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.assistance.openCancellationDialog}
                >
                    <DialogTitle>
                        <b>Termine assistenza</b>
                    </DialogTitle>
                    <DialogContent>
                        Sei sicuro di voler terminare la sessione di assistenza?
                    </DialogContent>
                    <DialogActions>
                        <div
                            align="center"
                            style={{
                                visibility: this.state.assistance
                                    .cancellationInProgress
                                    ? "visible"
                                    : "hidden"
                            }}
                        >
                            {<CircularProgress />}
                        </div>
                        {!this.state.assistance.cancellationInProgress && (
                            <div>
                                {" "}
                                <Button
                                    onClick={handleCancelCancellationDialog}
                                    color="primary"
                                >
                                    Annulla
                                </Button>
                                <Button
                                    onClick={handleDeleteProvisioning}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Ok
                                </Button>
                            </div>
                        )}
                    </DialogActions>
                </Dialog>
                <p
                    style={{
                        color: "#000000",
                        "font-style": "normal",
                        "white-space": "pre-wrap",
                        "font-size": "14px",
                        "margin-bottom": "0px",
                        "margin-left": "10px"
                    }}
                >
                    Accesso diretto al database gestionale
                </p>
                <span
                    style={{
                        "margin-top": "0px",
                        "margin-bottom": "0px"
                    }}
                >
                    <Button
                        color="primary"
                        disabled={true}
                        style={{
                            "padding-top": "0px"
                        }}
                    >
                        <em
                            style={{
                                color: "#000000",
                                "font-style": "normal",
                                "white-space": "pre-wrap"
                            }}
                        >
                            Stato sessione:{" "}
                        </em>
                        <em
                            style={{
                                color: statusColor,
                                "font-style": "normal"
                            }}
                        >
                            {this.state.assistance.status}
                        </em>
                    </Button>
                    <Tooltip
                        disableFocusListener
                        disableTouchListener
                        title="Avvia provisioning assistenza"
                    >
                        <Button
                            color="primary"
                            onClick={handleOpenConfirmationDialog}
                            disabled={
                                this.state.assistance.status !== "ASSENTE"
                            }
                        >
                            <IconRocket />
                        </Button>
                    </Tooltip>
                    <Tooltip
                        disableFocusListener
                        disableTouchListener
                        title="Elimina provisioning assistenza"
                    >
                        <Button
                            color="primary"
                            onClick={handleOpenCancellationDialog}
                            disabled={this.state.assistance.status !== "PRONTO"}
                        >
                            <DeleteIcon />
                        </Button>
                    </Tooltip>
                </span>
            </React.Fragment>
        );
    }
    renderContainerAccessDialog(data) {
        if (!this.state.showContainer) {
            return null;
        }
        const handleCloseContainerAccessDialog = () => {
            this.setState({
                showContainer: false
            });
        };
        const cliCommand =
            "aws ssm start-session --target " +
            data.cluster_instance_id +
            ' --document-name "AWS-StartInteractiveCommand" --parameters "command=sudo docker exec -ti ' +
            data.container_id +
            ' bash"';
        const webCommand =
            "sudo docker exec -ti " + data.container_id + " bash";
        return (
            <Dialog
                maxWidth={false}
                open={this.state.showContainer}
                onClose={handleCloseContainerAccessDialog}
            >
                <DialogTitle>Accesso al container</DialogTitle>
                <DialogContent
                    style={{
                        overflow: "visible",
                        overflowY: "visible"
                    }}
                >
                    <ul>
                        <li style={{ display: "table-cell" }}>
                            <TextField
                                label="CLI"
                                value={cliCommand}
                                editable={false}
                                InputProps={{
                                    endAdornment: (
                                        <Tooltip title="Copia comando terminale">
                                            <Button
                                                color="primary"
                                                target="_blank"
                                                onClick={() => {
                                                    copy(cliCommand);
                                                    this.setState({
                                                        snackBar: true
                                                    });
                                                }}
                                            >
                                                <FileCopyOutlinedIcon />
                                            </Button>
                                        </Tooltip>
                                    )
                                }}
                            />
                        </li>
                        <li
                            style={{
                                display: "table-cell",
                                float: "left",
                                marginTop: "48px"
                            }}
                        >
                            <TextField
                                label="Web"
                                value={webCommand}
                                editable={false}
                                InputProps={{
                                    endAdornment: (
                                        <Tooltip title="Copia comando web">
                                            <Button
                                                color="primary"
                                                target="_blank"
                                                onClick={() => {
                                                    copy(webCommand);
                                                    this.setState({
                                                        snackBar: true
                                                    });
                                                }}
                                            >
                                                <FileCopyOutlinedIcon />
                                            </Button>
                                        </Tooltip>
                                    )
                                }}
                            />
                        </li>
                    </ul>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCloseContainerAccessDialog}
                        color="primary"
                    >
                        <TranslatedText resource_name={"ra.actions.close"} />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    renderDBAccessDialog(data) {
        if (!this.state.showDB) {
            return null;
        }
        const handleCloseDBAccessDialog = () => {
            this.setState({
                showDB: false
            });
        };
        const cliCommand =
            "aws ssm start-session --target " +
            data.cluster_instance_id +
            ' --document-name "AWS-StartInteractiveCommand" --parameters "command=psql -h ' +
            data.rds_host +
            " -U " +
            data.rds_user +
            " " +
            data.rds_db_tse +
            '"';
        const webCommand =
            "psql -h " +
            data.rds_host +
            " -U " +
            data.rds_user +
            " " +
            data.rds_db_tse;
        return (
            <Dialog
                maxWidth={false}
                open={this.state.showDB}
                onClose={handleCloseDBAccessDialog}
            >
                <DialogTitle>Accesso al database</DialogTitle>
                <DialogContent
                    style={{
                        overflow: "visible",
                        overflowY: "visible"
                    }}
                >
                    <ul>
                        <li style={{ display: "table-cell" }}>
                            <TextField
                                label="CLI"
                                value={cliCommand}
                                editable={false}
                                InputProps={{
                                    endAdornment: (
                                        <Tooltip title="Copia comando terminale">
                                            <Button
                                                color="primary"
                                                target="_blank"
                                                onClick={() => {
                                                    copy(cliCommand);
                                                    this.setState({
                                                        snackBar: true
                                                    });
                                                }}
                                            >
                                                <FileCopyOutlinedIcon />
                                            </Button>
                                        </Tooltip>
                                    )
                                }}
                            />
                        </li>
                        <li
                            style={{
                                display: "table-cell",
                                float: "left",
                                marginTop: "48px"
                            }}
                        >
                            <TextField
                                label="Web"
                                value={webCommand}
                                editable={false}
                                InputProps={{
                                    endAdornment: (
                                        <Tooltip title="Copia comando web">
                                            <Button
                                                color="primary"
                                                target="_blank"
                                                onClick={() => {
                                                    copy(webCommand);
                                                    this.setState({
                                                        snackBar: true
                                                    });
                                                }}
                                            >
                                                <FileCopyOutlinedIcon />
                                            </Button>
                                        </Tooltip>
                                    )
                                }}
                            />
                        </li>
                    </ul>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDBAccessDialog} color="primary">
                        <TranslatedText resource_name={"ra.actions.close"} />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    handleCloseSnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        this.setState({
            snackBar: false
        });
    };

    render() {
        return (
            <React.Fragment>
                {this.props.data &&
                    this.props.permissions &&
                    (this.props.permissions.includes(
                        POLICY_INSTALLATIONS.GET_INFO
                    ) ||
                        this.props.permissions.includes(
                            POLICY_INSTALLATIONS.GET_LIMITED_INFO
                        ) ||
                        ((this.props.data.installation_type_id ===
                            this.state.enterprise_id ||
                            this.props.data.installation_type_id ===
                                this.state.enterprise12_id ||
                            this.props.data.installation_type_id ===
                                this.state.enterprise10_id) &&
                            this.props.permissions.includes(
                                POLICY_INSTALLATIONS.DATABASE_SUPPORT
                            ))) && (
                        <Button
                            color="primary"
                            target="_blank"
                            onClick={this.handleClickOpen}
                        >
                            <FormatListBulletedIcon
                                style={{ paddingRight: "0.4em" }}
                            />
                            DETTAGLI
                        </Button>
                    )}
                <Dialog
                    maxWidth={false}
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    <DialogTitle id="form-dialog-title">
                        <b>
                            {this.props.data
                                ? "Dettagli installazione " + this.props.data.id
                                : "Dati installazione non validi"}
                            {!this.state.loading &&
                                this.props.data.installation_type_id ===
                                    this.state.studio_id &&
                                this.props.permissions.includes(
                                    POLICY_INSTALLATIONS.GET_INFO
                                ) &&
                                this.renderSSHButtons(
                                    this.state.info.cluster_instance_id
                                )}
                            {!this.state.loading &&
                                this.props.data.installation_type_id ===
                                    this.state.studio_id &&
                                this.props.permissions.includes(
                                    POLICY_INSTALLATIONS.GET_INFO
                                ) &&
                                this.renderCopySSHCommand(
                                    this.state.info.cluster_instance_id
                                )}
                            {!this.state.loading &&
                                this.props.data.installation_type_id ===
                                    this.state.studio_id &&
                                (this.props.permissions.includes(
                                    POLICY_INSTALLATIONS.GET_INFO
                                ) ||
                                    this.props.permissions.includes(
                                        POLICY_INSTALLATIONS.GET_LIMITED_INFO
                                    )) &&
                                this.renderMoreOptionsMenu(this.state.info)}
                            {!this.state.loading &&
                                (this.props.data.installation_type_id ===
                                    this.state.enterprise_id ||
                                    this.props.data.installation_type_id ===
                                        this.state.enterprise12_id ||
                                    this.props.data.installation_type_id ===
                                        this.state.enterprise10_id) &&
                                this.props.permissions.includes(
                                    POLICY_INSTALLATIONS.DATABASE_SUPPORT
                                ) &&
                                this.renderEnterpriseAssistance()}
                            {// Nel caso Enterprise devo vedere il menu con le operazioni aggiuntive
                            // solo se almeno uno delle tre è presente
                            (this.props.data.installation_type_id ===
                                this.state.enterprise_id ||
                                this.props.data.installation_type_id ===
                                    this.state.enterprise10_id) &&
                                (this.state.enterpriseOperationsStatus[
                                    OperationType.LicenseUpdate
                                ] ||
                                    this.state.enterpriseOperationsStatus[
                                        OperationType.MenuUpdate
                                    ] ||
                                    this.state.enterpriseOperationsStatus[
                                        OperationType.GenerateBackup
                                    ]) &&
                                this.renderMoreOptionsMenuEnterprise()}
                        </b>
                    </DialogTitle>
                    <DialogContent
                        style={{
                            overflow: "visible",
                            overflowY: "visible"
                        }}
                    >
                        {this.state.loading && <CircularProgress />}
                        {!this.state.loading && this.myDialog()}
                        {!this.state.loading &&
                            this.props.data.installation_type_id ===
                                this.state.studio_id &&
                            this.renderContainerAccessDialog(this.state.info)}
                        {!this.state.loading &&
                            this.props.data.installation_type_id ===
                                this.state.studio_id &&
                            this.renderDBAccessDialog(this.state.info)}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            <TranslatedText
                                resource_name={"ra.actions.close"}
                            />
                        </Button>
                    </DialogActions>
                    <Snackbar
                        open={this.state.snackBar}
                        onClose={this.handleCloseSnackbar}
                        message="Comando copiato"
                        autoHideDuration={1000}
                    />
                </Dialog>
                <RefreshListActions
                    refreshInterval={
                        !this.state.open ? this.props.refreshInterval : null
                    }
                />
            </React.Fragment>
        );
    }
}

export default compose(
    connect(
        null,
        {
            showNotification
        }
    )
)(DetailsDialogButton);



// WEBPACK FOOTER //
// ./src/components/DetailsDialogButton.js